import { useAppStore } from '../app/state/useAppStore';
import { isCapabilityAvailable } from '../licensing/entitlements';
import type { Capability } from './capabilities';

export function useCapability(capability: Capability): boolean {
  return useAppStore((state) => isCapabilityAvailable(state.entitlement, capability));
}
